import DashboardSettings_Details from './container';

export default DashboardSettings_Details;



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Details/index.js